import SimpleCard, { ICardProperties } from "components/controls/SimpleCard";
import {
    IAccountsReceivable as FAM_IAccountsReceivable
} from "model/FlexibleAttributeModel";

export interface IAccountsReceivableCard extends ICardProperties {
    accountsReceivable: FAM_IAccountsReceivable;
}

const AccountsReceivableCard: React.FC<IAccountsReceivableCard> = (props) => {
    const { accountsReceivable } = props;
    return <SimpleCard
        key={accountsReceivable.id}
        header="AR"
        description={accountsReceivable.name ?? ""}
        {...props}
    />
}

export default AccountsReceivableCard;